export default __webpack_public_path__ + "static/media/two-people.55d52187.png";